import { Button, SxProps } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  label?: string;
  variant: "text" | "outlined" | "contained";
  onClick: () => void;
  colorTheme: any;
  sx?: SxProps;
  children?: ReactNode;
};

const FilterSelect = (props: Props) => {
  return (
    <Button
      variant={props.variant}
      size="large"
      onClick={(e) => {
        props.onClick();
      }}
      color={props.colorTheme}
      sx={{
        height: "40px",
        minWidth: "80px",
        maxWidth: "160px",
        borderRadius: "0px",
        fontSize: "12px",
        overflowWrap: "break-word",
        ...props.sx,
      }}
    >
      {props.label && props.label}
      {props.children && props.children}
    </Button>
  );
};

export default FilterSelect;
